<div style="margin-top: 30px; margin-bottom: 30px;" class="container">
  <div class="card">
    <div class="card-body">
      <h5 class="card-title zaya-form-header" i18n="button|Where a user can login.@@buttonLogin">
        Login
      </h5>
      <app-loader *ngIf="isLoading"></app-loader>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="email" i18n="label|The email of a user.@@labelEmail" class="zaya-form-sub-header">Email</label>
          <input type="email" id="email" class="form-control" formControlName="email">
          <span
            class="help-block"
            *ngIf="loginForm.get('email').invalid && loginForm.get('email').touched"
            i18n="error message|The message shown when an email has not been entered.@@errorEmail">
              Please enter a valid email.
          </span>
        </div>

        <div class="form-group">
          <label for="password" i18n="label|The password of a user.@@labelPassword" class="zaya-form-sub-header">Password</label>
          <input type="password" id="password" class="form-control" formControlName="password">
          <span
            class="help-block"
            *ngIf="loginForm.get('password').invalid && loginForm.get('password').touched"
            i18n="error message|The message shown when a password is not valid.@@errorPassword">
              Please enter a valid password.
          </span>
        </div>

        <div *ngIf="error" class="alert alert-danger">
          <span>{{error}}</span>
        </div>

        <div class="d-flex flex-fill justify-content-center">
          <button class="btn btn-primary login-btn mt-3" type="submit" i18n="button|Where a user can login.@@buttonLogin">Login</button>
        </div>
      </form>
    </div>
  </div>
</div>
